<template>
  <v-dialog
    v-if="dialog"
    v-model="newDialog"
    v-bind="$attrs"
    :scrollable="isScrollable"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="cancelAction"
  >
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div v-if="loading">
      <v-skeleton-loader
        class="mx-auto d-none d-md-block"
        type="article, actions"
      ></v-skeleton-loader>

      <v-skeleton-loader
        class="mx-auto d-md-none"
        type="list-item-avatar, list-item-three-line, table-tfoot, list-item-two-line, article, table-heading, list-item-three-line, actions"
      ></v-skeleton-loader>
    </div>
    <v-card v-else>
      <v-card-title class="px-3 py-0 px-md-5 py-md-1">
        <span class="text-subtitle-2 text-sm-subtitle-1 text-md-h6 text-lg-h5 font-weight-bold">{{newTitle}}</span>
        <v-spacer></v-spacer>
          <v-btn
            text
            icon
            title="Cancelar"
            class="my-2"
            @click="cancelAction"
          >
            <v-icon right dark>mdi-close-circle</v-icon>
          </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text id="dialogBody" class="mt-5 px-3 px-sm-4 px-md-6">
        <v-alert
          type="error"
          elevation="2"
          v-if="formErrors.length > 0"
          dismissible
          class="mt-2"
          @input="errorsAlertClose"
        >
          <p v-for="error in formErrors" class="mb-0">
            {{error}}
          </p>
        </v-alert>

        <slot name="newForm"></slot>

      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-2 py-0 px-md-4 py-md-1">
        <v-btn class="my-2" @click="cancelAction">
          {{newCancelButtonLabel}}
        </v-btn>

        <v-spacer></v-spacer>

        <slot name="action1"></slot>
        <slot name="action2"></slot>
        <slot name="action3"></slot>
        <slot name="action4"></slot>
        <slot name="action5"></slot>

        <v-btn color="success" class="my-2 d-none d-sm-inline-flex" v-if="saveAndAddOtherButtonEnabled" :disabled="newSaveButtonDisabled" @click.stop="confirmSaveAndAddOtherAction">
          {{newSaveAndAddOtherButtonLabel}}
          <v-icon right dark>mdi-content-save</v-icon>
        </v-btn>

        <v-btn color="success" class="my-2 d-sm-none" v-if="saveAndAddOtherButtonEnabled" :disabled="newSaveButtonDisabled" @click.stop="confirmSaveAndAddOtherAction">
          <v-icon right dark>mdi-content-save</v-icon>
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>

        <v-btn color="success" class="my-2" :disabled="newSaveButtonDisabled" @click.stop="confirmAction" v-if="!hideSaveButton">
          {{newSaveButtonLabel}}
          <v-icon right dark>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on: dialog }" @open-dialog="openAction" v-if="!useModelInsteadOfButton">
      <slot name="open_button" v-bind="dialog" v-if="usesOpenButtonSlot"></slot>
      <v-tooltip top v-else>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn v-if="!inlineAddButton"
            color="primary"
            class="ma-1 d-none d-md-flex"
            v-on="{ ...dialog }"
            @click="openAction"
            :disabled="createButtonDisabled">
              {{!createButtonWithoutLabel ? newCreateButtonLabel : null}}
            <v-icon right dark>{{addButtonIcon}}</v-icon>
          </v-btn>

          <v-btn v-if="!inlineAddButton"
            class="d-md-none mt-2"
            color="primary"
            absolute
            right
            fab
            :small="$vuetify.breakpoint.xsOnly"
            v-on="{ ...dialog }"
            @click="openAction"
            :disabled="createButtonDisabled"
          >
            <v-icon>{{addButtonIcon}}</v-icon>
          </v-btn>

          <v-icon v-else v-show="showButton"
            v-on="{ ...tooltip, ...dialog }"
            class="mx-1"
            @click="openAction"
            :disabled="createButtonDisabled">
          >
            {{addButtonIcon}}
          </v-icon>
        </template>
        <span>{{newCreateButtonLabel}}</span>
      </v-tooltip>
    </template>
  </v-dialog>
  <div v-else class="col">

    <slot name="newForm"></slot>

    <v-btn class="my-2" @click="cancelAction">
      {{newCancelButtonLabel}}
    </v-btn>

    <v-btn color="success" class="my-2" :disabled="newSaveButtonDisabled" @click="confirmAction" v-if="!hideSaveButton">
      {{newSaveButtonLabel}}
      <v-icon right dark>mdi-content-save</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newDialog: false,
      newSaveButtonDisabled: false,
    };
  },
  props: {
    // newDialog: {
    //   type: Boolean,
    //   default: false
    // },
    showButton:{
      type: Boolean,
      default: true,
    },
    showNesteds: {
      type: Boolean,
      default: true,
    },
    useModelInsteadOfButton: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      default: true
    },
    saveAndAddOtherButtonEnabled: {
      type: Boolean,
      default: false
    },
    createButtonDisabled: {
      type: Boolean,
      default: false
    },
    formErrors: {
      type: Array,
      default: () => []
    },
    isScrollable: {
      type: Boolean,
      default: true
    },
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    usesOpenButtonSlot: {
      type: Boolean,
      default: false
    },
    createButtonWithoutLabel: {
      type: Boolean,
      default: false
    },
    addButtonIcon: {
      type: String,
      default: "mdi-plus"
    },
    modelNameSingular: {
      type: String,
      default: "Registro"
    },
    modelNamePlural: {
      type: String,
      default: "Registros"
    },
    newTitle: {
      type: String,
      default: function() {
        return "Criação de " + this.modelNameSingular
      }
    },
    newCreateButtonLabel: {
      type: String,
      default: function() {
        return "Adicionar " + this.modelNameSingular
      }
    },
    newCancelButtonLabel: {
      type: String,
      default: "Cancelar"
    },
    newSaveButtonLabel: {
      type: String,
      default: "Salvar"
    },
    hideSaveButton: {
      type: Boolean,
      default: false,
    },
    newEntry: {
      type: Object,
      default: null,
    },
    newSaveAndAddOtherButtonLabel: {
      type: String,
      default: "Salvar e Adicionar Outro"
    },
    loading: {
      type: Boolean,
      default: true
    },
    pageLoading: {
      type: Boolean,
      default: false
    },

  },
  watch: {
    formErrors: function(val) {
      if (val && val.length > 0) {
        // console.log("scroll")
        // document.getElementById('dialogBody').scrollTop = 0;
        let options = {
          container: '#dialogBody',
          duration: 300,
          offset: 0,
        }
        if(document.getElementById("dialogBody")){
          this.$vuetify.goTo(0, options);
        }
      }
    }
  },
  mounted() {
    // Close modal with 'esc' key
    // document.addEventListener("keydown", (e) => {
    //     if (e.keyCode == 27) {
    //         this.cancelAction();
    //     }
    // });
  },
  methods: {
    cancelAction: function(){
      this.closeDialog();
      this.$emit("new-cancel-action")
    },
    confirmAction: function() {
      this.newSaveButtonDisabled = true;
      this.$emit("new-confirm-action");
      setTimeout(() => {
      	this.newSaveButtonDisabled = false;
      }, 2000);
    },
    confirmSaveAndAddOtherAction: function() {
      this.newSaveButtonDisabled = true;
      this.$emit("new-confirm-and-add-other-action");
      setTimeout(() => {
      	this.newSaveButtonDisabled = false;
      }, 2000);
    },
    openAction: function() {
      this.newDialog = true;
      this.$emit("new-open-action");
      this.newSaveButtonDisabled = false;
    },
    closeDialog: function() {
      this.newDialog = false;
    },
    errorsAlertClose: function(val) {
      if (!val) {
        this.$emit("clear-form-errors");
      }
    }
  },
};
</script>

<style scoped>
  ::v-deep .v-slide-group__prev, .v-slide-group__prev--disabled {
    display: none !important;
  }
</style>
